import { Table } from "antd";
import styled from "styled-components";
import { theme } from "../../../../theme";

const CustomTable = styled(Table)`
  & .ant-table-container {
    & .ant-table-thead {
      & tr > th {
        ${theme.typo.heading.b14};
      }
    }
  }
`;

export { CustomTable };
